<template>
    <div class="card">
        <img :src="require(`@/assets/${image}`)" />
        <div class="text">
            <h2>{{ title }}</h2>
            <p>
                <slot></slot>
            </p>
            <router-link id="next" :to="link"><button>Read the Case Study</button></router-link>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Card',
    props: {
        image: String,
        title: String,
        link: String,
    }
};
</script>

<style scoped>
    .card{
        display: flex;
        flex-direction: row;
        background-color: #2B2927;
        border-radius: 12px;
        justify-content: center;
        align-items: center;
        max-width: 1300px;
        margin: 30px auto;
        padding: 30px;
        box-sizing: border-box;
        width: 100%;
    }
    .card img{
        display: flex;
        flex: 1;
        padding: 30px;
        width: stretch;
        object-fit: contain;
        height: auto;
        max-height: 170px;
        margin: auto;
    }
    .card .text{
        flex: 3;
        text-align: center;
    }
    h2{
        font-size: 2.2em;
        font-weight: 500;
    }
    p{
        font-size: 1em;
        color: black;
        margin-top: 20px;
    }
    #next{
        text-decoration: none;
        display: block;
        margin-top: 35px;
    }

    #next button{
        font-size: 1.1em;
        font-weight: bold;
        color: #0E0C0A;
        background-color: #C5B9A6;
        padding:15px;
        border: none;
        border-radius: 12px;
        cursor: pointer;
    }

    #next:hover{
        filter: brightness(0.6);
        transition: 0.4s;
    }

    @media only screen and (max-width: 900px){
            .card{
                display: flex;
                flex-direction: column;
            }

            h2{
                font-size: 1.5em;
            }

            p{
                font-size: 0.9em;
            }

            #next{
                font-size: 1em;
            }
    }

    @media only screen and (max-width: 700px){
        .card{
                        padding-bottom: 80px;
                    }
    }
</style>